import { gql } from "@apollo/client";

export const API_KEY_GET_GIFT_CARD_OFFERS = gql`
  query ApiKeyGetGiftCardOffers(
    $country: String!
    $searchText: String
    $category: String
    $sortOrder: String
    $pageNumber: Int
    $pageSize: Int
    $isPreflight: Boolean
    $filterForWithdrawal: Boolean
    $isPremium: Boolean
  ) {
    offers: getApprovedGiftCardOffers(
      country: $country
      searchText: $searchText
      category: $category
      sortOrder: $sortOrder
      pageNumber: $pageNumber
      pageSize: $pageSize
      isPreflight: $isPreflight
      filterForWithdrawal: $filterForWithdrawal
      isPremium: $isPremium
    ) {
      docs
      totalDocs
    }
  }
`;
